
<div>
    <d-service-partner
        v-if        = "company"
        v-model     = "edit"
        :company-id = "company.id"
        @stored     = "onStored"
    />
    <v-card flat @click="onCompany" :ripple="false" >
        <div
            class="company lm-border pa-3 pt-2"
            :class="background"
            style="position:relative;"
        >
            <div class="header">
                <div class="v-flex" style="margin-top: -3px">
                    <div class="name primary--text" >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">{{ company.id }} - {{ company.name }}</span>
                            </template>
                            <span>{{ company.name }}</span>
                        </v-tooltip>
                    </div>
                    <v-spacer />
                    <div>
                        <company-roles
                            :item="company"
                        />
                    </div>

                </div>
            </div>
            <div class="subtitle">
                {{ company.nameAdd }}
            </div>


            <div >
                <div class="adress v-flex">
                    <div>
                        {{ company.zip }} {{ company.city }}
                    </div>
                </div>
                <div class="adress v-flex">
                    <div>
                        {{ company.street }}
                    </div>
                </div>
            </div>
            <div
                v-if="allowEdit"
                style="position: absolute; bottom: 2px; right: 2px"
            >
                <c-toolbar-button
                    icon     = "mdi-pencil"
                    tooltip  = "Bearbeiten"
                    color    = "primary"
                    size     = "20"
                    @click   = "onEdit"
                />
            </div>
        </div>
    </v-card>
</div>
